import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import styled from "styled-components";
import ProductImage from "./product/product-img";
import ProductButton from "./product/product-button";
import ProductTitle from "./product/product-title";

const ProductWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ $alignButtons }) =>
    $alignButtons ? "space-between" : "flex-start"};
  cursor: pointer;
  border: 1px solid var(--color-accent3);
  min-width: 100%;
  background-color: var(--color-secondary);

  &:nth-child(even) {
    margin-top: 2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      margin-top: 0;
    }
  }
  &:nth-child(odd) {
    margin-bottom: 2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      margin-bottom: 0;
    }
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;
const StyledSpan = styled.span`
  margin-right: 0.5rem;
  text-transform: uppercase;
  font-size: 0.8rem;
  opacity: 0.6;
  width: fit-content;
`;
const BottomContent = styled.div`
  background-color: var(--color-secondary);
  padding: 1.25rem;
`;

const ProductBlock = ({
  product,
  showAddToCartButton,
  showTitle,
  alignButtons,
}) => {
  return (
    <ProductWrapper $alignButtons={alignButtons}>
      <StyledLink
        to={product.uri || product.link}
        aria-label="gå til produktet"
      >
        {product.image && <ProductImage image={product.image} />}
      </StyledLink>
      <BottomContent>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {product?.productCategories?.nodes?.map((category, index) => (
            <StyledSpan key={index}>{category.name}</StyledSpan>
          ))}
        </div>
        {showTitle && (
          <ProductTitle name={product.name} align="left" fontSize="small" />
        )}
        {showAddToCartButton && (
          <ProductButton product={product} alignButtons={alignButtons} />
        )}
      </BottomContent>
    </ProductWrapper>
  );
};

ProductBlock.propTypes = {
  product: PropTypes.shape({
    image: PropTypes.object,
    name: PropTypes.string,
    shortDescription: PropTypes.string,
    uri: PropTypes.string,
    link: PropTypes.string,
    variations: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.object),
    }),
    productCategories: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
  showAddToCartButton: PropTypes.bool,
  showPrice: PropTypes.bool,
  showTitle: PropTypes.bool,
  alignButtons: PropTypes.bool,
  currency: PropTypes.string,
  priceDecimalSeparator: PropTypes.string,
  priceThousandSeparator: PropTypes.string,
};

export default ProductBlock;
